import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from '../../../services/shared.service';
import { Store } from '@ngxs/store';
import { ClientSelectionState } from '../../../state/ClientSelectionState/ClientSelection.state';
import { ClientFeatureWhitelistService } from '../../../services/client-feature-whitelist.service';
import { PayDateInfoEx, TimeclockModel } from '../../../models/payroll';
import { AppConfigService } from '../../../services/app-config.service';

@Component({
  selector: 'lib-timeclock-check',
  templateUrl: './timeclock-check.component.html',
  styleUrls: ['./timeclock-check.component.scss'],
  standalone: false
})
export class TimeclockCheckComponent implements OnInit {
  public selCalendarId: number | null;

  public showLegacyComponent = false;

  public showEditor = false;

  public fileToEdit: { file: TimeclockModel; pdi: PayDateInfoEx };

  constructor(
    private store: Store,
    private sharedService: SharedService,
    private route: ActivatedRoute,
    private router: Router,
    private clientWhitelistService: ClientFeatureWhitelistService,
    private appConfigService: AppConfigService
  ) {}

  ngOnInit(): void {
    const queryParams = this.route.snapshot.queryParamMap;
    this.selCalendarId = queryParams.has('calendar_id') ? +queryParams.get('calendar_id') : null;
    this._validateManualChecks();

    this.store.selectOnce(ClientSelectionState.clientSetup).subscribe(setup => {
      if (!setup.HasTimeclock) {
        //user does not have timeclock.
        // user does not have timeclock service, go to payroll start
        this.sharedService.timeclockSelection = {};
        this._goToPayrollStart();
      } else {
        if (this.appConfigService.getConfig().EnableNewTimeclock) {
          this.store.selectOnce(ClientSelectionState.clientCode).subscribe(code => {
            this.clientWhitelistService
              .checkWhitelistForFeature(code, 'timeclockUpload')
              .subscribe(result => {
                this.showLegacyComponent = !result;
              });
          });
        } else {
          this.showLegacyComponent = true;
        }
      }
    });
  }

  public displayEditor(file: { file: TimeclockModel; pdi: PayDateInfoEx }) {
    this.fileToEdit = file;
    this.showEditor = true;
  }

  public hideEditor() {
    this.showEditor = false;
    this.fileToEdit = null;
  }

  private _goToPayrollStart(params?: {}) {
    // if calendar_id query param exists, append it back to the query params
    // to the payroll start page
    if (this.selCalendarId) {
      params = { ...params, ...{ calendar_id: this.selCalendarId } };
    }
    this.store.selectOnce(ClientSelectionState.clientCode).subscribe(code => {
      this.router.navigate([`/client/${code}/payroll`], { queryParams: params });
    });
  }

  private _getQueryParams(params?: {}) {
    // if calendar_id query param exists, append it back to the query params
    // to the payroll start page
    if (this.route.snapshot.queryParamMap.has('calendar_id')) {
      params = {
        ...params,
        ...{ calendar_id: this.route.snapshot.queryParamMap.get('calendar_id') }
      };
    }

    if (this.route.snapshot.queryParamMap.has('payType')) {
      params = { ...params, ...{ payType: this.route.snapshot.queryParamMap.get('payType') } };
    }

    return params;
  }

  private _validateManualChecks() {
    if (this.sharedService.manualChecks == null) {
      // We have never visited the manual checks screen, likely because the user refreshed the page
      // Go back there so we can prompt user for any checks
      this.store.selectOnce(ClientSelectionState.clientCode).subscribe(code => {
        this.router.navigate([`/client/${code}/manual-checks`], {
          queryParams: this._getQueryParams()
        });
      });

      return;
    }
  }
}
